import { ApolloClient, ApolloLink, fromPromise, InMemoryCache, NextLink, Observable, Operation } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { IAuthToken } from '@transferz/fe-models';
import { getItem } from '@transferz/fe-utils/src/storage/getItem';

import { REFRESH_TOKEN } from './typeDefs/auth';
import { httpLink } from './unauthorisedClient';

let isRefreshing = false;
let pendingRequests: any[] = [];

const resolvePendingRequests = (refreshToken: any) => {
  pendingRequests.map(callback => callback(refreshToken));
  pendingRequests = [];
};

function getRefreshToken() {
  return getItem<IAuthToken>('authToken')?.refreshToken;
}

const httpClient = new ApolloClient({
  link: ApolloLink.from([
    onError(() => {
      // todo: log the user out
    }),
    httpLink,
  ]),
  cache: new InMemoryCache(),
});

export function refreshToken(operation: Operation, forward: NextLink) {
  let forward$: Observable<any>;

  if (!isRefreshing) {
    isRefreshing = true;
    const promise = httpClient.mutate({ mutation: REFRESH_TOKEN, variables: { token: getRefreshToken() } })
      .then(({ data: { refreshToken } }) => {
        localStorage.setItem('authToken', JSON.stringify(refreshToken));
        resolvePendingRequests(refreshToken);
        return refreshToken;
      })
      .catch((e) => {
        console.error('Error while refreshing token, the result is empty dashboard', e);
        localStorage.removeItem('authToken');
        window.location.href = '/';
      })
      .finally(() => {
        isRefreshing = false;
      });

    forward$ = fromPromise(promise).filter(value => Boolean(value));
  } else {
    forward$ = fromPromise(
      new Promise<void>(resolve => {
        pendingRequests.push((refreshToken: any) => {
          resolve(refreshToken);
        });
      }),
    );
  }

  return forward$.flatMap(refreshToken => {
    operation.setContext({
      headers: {
        Authorization: `Bearer ${refreshToken.accessToken}`,
      },
    });
    return forward(operation);
  });
}
